import { jwtDecode } from "jwt-decode";

class Auth {
  constructor() {
    if (Auth.instance) {
      return Auth.instance;
    }
    Auth.instance = this;

    this.authenticated = false;
    this.token = "";
    this.credentials = null;
    this.roles = "";
    this.listeners = [];

    this.initializeFromStorage();
  }

  initializeFromStorage() {
    const token = localStorage.getItem('token');
    if (token) {
      this.setAuthState(token);
    }
  }

  setAuthState(token) {
    this.authenticated = true;
    this.token = token;
    this.roles = this.getUserRoleFromToken(token);
    localStorage.setItem('token', token);
    this.notifyListeners(); // Notificar cambio
  }

  subscribe(listener) {
    if (!this.listeners.includes(listener)) {
      this.listeners.push(listener);
    }
  }

  unsubscribe(listener) {
    const index = this.listeners.indexOf(listener);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }

  notifyListeners() {
    this.listeners.forEach(listener => {
      if (typeof listener === 'function') {
        listener();
      }
    });
  }

  login(credentials, token) {
    this.credentials = credentials;
    this.setAuthState(token);
    this.notifyListeners(); // Notificar cambio
  }

  logout() {
    this.authenticated = false;
    this.token = "";
    this.credentials = null;
    this.roles = "";
    localStorage.removeItem('token');
    this.notifyListeners(); // Notificar cambio
  }

  isAuthenticated() {
    return this.authenticated;
  }

  isAdmin() {
    return this.authenticated && this.roles.toUpperCase().split(" ").includes("ADMIN");
  }

  hasRole(role) {
    return this.roles.toUpperCase().split(" ").includes(role.toUpperCase());
  }

  getUserRoleFromToken(token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.scope || "";
    } catch (error) {
      console.error("Error decoding JWT", error);
      return "";
    }
  }

  getUserID() {
    try {
      const decodedToken = jwtDecode(localStorage.getItem("token"));
      return decodedToken.userId; 
    } catch (error) {
      console.error("Error decoding JWT", error);
      return "";
    }
  }
}

const instance = new Auth();

export default instance;